import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {PlayerConfigurationEdit} from '../models/player-configuration';

export const playerConfigurationEditActionTypes = {
  LOAD: type('[player Configuration Edit] Load'),
  LOAD_CLIENT: type('[player Configuration Edit] Load Client'),
  LOAD_SUCCESS: type('[player Configuration Edit] Load Success'),
  LOAD_FAIL: type('[player Configuration Edit] Load Server Error'),
  CLEAR: type('[player Configuration Edit] Clear')
};

export class LoadPlayerConfigurationEditAction implements Action {
  readonly type = playerConfigurationEditActionTypes.LOAD;
  constructor() {}
}

export class LoadPlayerConfigurationEditClientAction implements Action {
  readonly type = playerConfigurationEditActionTypes.LOAD_CLIENT;
  constructor() {}
}

export class LoadPlayerConfigurationEditSuccessAction implements Action {
  readonly type = playerConfigurationEditActionTypes.LOAD_SUCCESS;
  constructor(public payload?: PlayerConfigurationEdit[]) {}
}

export class LoadPlayerConfigurationEditFailAction implements Action {
  readonly type = playerConfigurationEditActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class ClearPlayerConfigurationEditFailAction implements Action {
  readonly type = playerConfigurationEditActionTypes.CLEAR;
  constructor(public payload?: string) {}
}
